{
  "apiVersion": "agents.t-ceratops.io/v1",
  "kind": "Agent",
  "metadata": {
    "name": "invoice-assistant",
    "tenant": "acme",
    "version": "1.2.0",
    "owner": "team-finance-ops",
    "description": { "en": "Answers invoice questions and schedules approved payments", "ar": "يجيب عن أسئلة الفواتير ويجدول المدفوعات المعتمدة" }
  },
  "spec": {
    "role": { "en": "Accounts payable assistant", "ar": "مساعد الحسابات الدائنة" },
    "goals": [{ "en": "Resolve invoice queries with cited sources", "ar": "حل استفسارات الفواتير مع ذكر المصادر" }],
    "pattern": "custom",
    "model": { "alias": "chat-default" },
    "tools": [{ "ref": "erp", "actions": ["read_invoice", "post_payment"] }],
    "knowledge": [{ "collection": "policies-kb", "top_k": 8 }],
    "risk_tier": 2,
    "approvals": [{ "tool": "erp", "action": "post_payment", "approver_roles": ["finance-approver"], "sla": "PT4H" }],
    "graph": {
      "entry": "retrieve",
      "nodes": [
        { "id": "retrieve", "type": "retrieval", "collection": "policies-kb", "label": { "en": "Find policy", "ar": "البحث في السياسات" } },
        {
          "id": "think",
          "type": "llm",
          "max_iterations": 6,
          "tools": ["erp"],
          "prompt": { "template": "You are an accounts payable assistant. Use the policy passages found ({context}) and cite the policy section you rely on. Look up the invoice before proposing a payment, and never pay without an approved request. Answer in the user's language.", "variables": ["context"] },
          "label": { "en": "Reason", "ar": "التفكير" }
        },
        {
          "id": "lookup",
          "type": "tool",
          "tool": "erp",
          "action": "read_invoice",
          "args": { "invoice_id": "{{ state.tool_call.args.invoice_id }}" },
          "label": { "en": "Get invoice", "ar": "جلب الفاتورة" }
        },
        {
          "id": "approve",
          "type": "human_approval",
          "subject_key": "tool_call",
          "approver_roles": ["finance-approver"],
          "on_reject": "think",
          "label": { "en": "Approve payment", "ar": "اعتماد الدفع" }
        },
        {
          "id": "pay",
          "type": "tool",
          "tool": "erp",
          "action": "post_payment",
          "args": {
            "body": {
              "invoice_id": "{{ state.tool_call.args.body.invoice_id }}",
              "amount": "{{ state.tool_call.args.body.amount }}",
              "currency": "{{ state.tool_call.args.body.currency }}"
            }
          },
          "label": { "en": "Schedule payment", "ar": "جدولة الدفع" }
        },
        { "id": "done", "type": "end", "label": { "en": "Done", "ar": "تم" } }
      ],
      "edges": [
        { "from": "retrieve", "to": "think" },
        { "from": "think", "to": "lookup", "when": "exists(state.tool_call) and state.tool_call.action == \"read_invoice\"" },
        { "from": "lookup", "to": "think" },
        { "from": "think", "to": "approve", "when": "exists(state.tool_call) and state.tool_call.action == \"post_payment\"" },
        { "from": "approve", "to": "pay" },
        { "from": "pay", "to": "done" },
        { "from": "think", "to": "done", "when": "not exists(state.tool_call)" }
      ]
    }
  }
}
